import { User } from "../user";
import { NameSpecifiedEntity } from "../entity";

export class ProjectTeamMember extends NameSpecifiedEntity<string> {
  constructor(public user: User, public isManager: boolean) {
    super(user.id, user.name);
  }

  clone(): ProjectTeamMember {
    return new ProjectTeamMember(this.user, this.isManager);
  }
}
